import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanEditTemplate(loggedInUser, template) {
    if (loggedInUser.role === Role.ADMIN) {
        return true;
    }

    if (loggedInUser.role === Role.MANAGER) {
        const userGroups = loggedInUser.groups.map(value => value.id);
        const templateGroups = template.groups.map(value => value.id);
        return userGroups.some(r=> templateGroups.indexOf(r) >= 0);
    }

    return false
}
export default CanEditTemplate;